var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.active)?_c('div',{attrs:{"id":"viewport"}},[_c('p',[_vm._v(_vm._s(_vm.viewport))]),_c('div',{attrs:{"id":"is-xxl"}}),_c('div',{attrs:{"id":"is-xl"}}),_c('div',{attrs:{"id":"is-lg"}}),_c('div',{attrs:{"id":"is-md"}}),_c('div',{attrs:{"id":"is-sm"}}),_c('div',{attrs:{"id":"is-xs"}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }